'use client'

import { useState, useEffect, useContext } from 'react'
import { Alert, AlertDescription } from '@/components/ui/shadcn/alert'
import { Loader2, AlertCircle } from 'lucide-react'
import { AuthContext } from '@/contexts/AuthContext'
import axios from '@/lib/api/axios'
import KeyMetric from '@/components/features/dashboard/KeyMetric'

function getPercentage(value, limit) {
  return ((value / limit) * 100).toFixed(2) + '%'
}

export default function Billing({ billingDetails }) {
  const [usage, setUsage] = useState(null)
  const [error, setError] = useState(null)
  const authContext = useContext(AuthContext)

  useEffect(() => {
    const fetchUsage = async () => {
      try {
        const { data } = await axios(
          `/organization/${authContext.user.organization.id}/current-usage`,
          { method: 'GET' },
          authContext,
          true, // Set Content-Type
          'billing', // Use Billing URL
        )
        setUsage(data)
      } catch {
        setError('Failed to load usage data')
      }
    }

    fetchUsage()
  }, [authContext])

  if (!usage) {
    return (
      <div className="vertically-centered">
        <Loader2 className="size-6 animate-spin" />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 flex-1">
      {error && (
        <div className="col-span-4">
          <Alert variant="destructive">
            <AlertCircle className="size-4" />
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        </div>
      )}
      <div>
        <KeyMetric
          identifier="inputTokens"
          title="Input Tokens"
          value={usage.totalInputTokens?.toLocaleString()}
          subtitle="This month"
          trend={`${getPercentage(
            usage.totalInputTokens,
            billingDetails.inputTokenLimit,
          )} Used`}
          onClick={() => {}}
          color="blue"
        />
      </div>
      <div>
        <KeyMetric
          identifier="outputTokens"
          title="Output Tokens"
          value={usage.totalOutputTokens?.toLocaleString()}
          subtitle="This month"
          trend={`${getPercentage(
            usage.totalOutputTokens,
            billingDetails.outputTokenLimit,
          )} Used`}
          onClick={() => {}}
          color="blue"
        />
      </div>
      <div>
        <KeyMetric
          identifier="minutes"
          title="Meeting Minutes"
          value={usage.totalMinutes?.toLocaleString()}
          subtitle="This month"
          trend={`${getPercentage(
            usage.totalMinutes,
            billingDetails.minuteLimit,
          )} Used`}
          onClick={() => {}}
          color="orange"
        />
      </div>
    </div>
  )
}
